import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { Lock } from 'lucide-react';
export function Offer() {
  return <section id="offer" className="bg-navy py-20 px-6 relative" data-id="element-158">
      <div className="max-w-5xl mx-auto" data-id="element-159">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden" data-id="element-160">
          <div className="grid md:grid-cols-2" data-id="element-161">
            <div className="p-10 md:p-12 flex flex-col justify-center" data-id="element-162">
              <FadeIn data-id="element-163">
                <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-164">
                  Asegura tu Legado Hoy
                </h2>
                <p className="text-xl text-gray-600 mb-8" data-id="element-165">
                  Obtén el sistema completo "El Family Vault Digital" por un
                  pago único.
                </p>

                <div className="flex items-end gap-3 mb-8" data-id="element-166">
                  <span className="text-3xl text-gray-400 line-through mb-1" data-id="element-167">
                    $49
                  </span>
                  <span className="text-6xl font-bold text-gold" data-id="element-168">$19</span>
                  <span className="text-xl text-gray-500 mb-2" data-id="element-169">USD</span>
                </div>
                <span className="inline-block bg-red-100 text-red-700 font-bold text-sm px-3 py-1 rounded-full mb-6" data-id="element-170">
                  ¡Ahorra 61% — Oferta por tiempo limitado!
                </span>

                <p className="text-lg text-gray-700 mb-8 italic" data-id="element-171">
                  Es una inversión mínima para asegurar que el esfuerzo de toda
                  una vida esté protegido y accesible para siempre.
                </p>

                <Button className="w-full text-center py-5 text-xl" data-id="element-172">
                  ¡QUIERO ORGANIZAR MI LEGADO FAMILIAR AHORA!
                </Button>

                <div className="flex items-center justify-center gap-2 mt-6 text-gray-500" data-id="element-173">
                  <Lock className="w-5 h-5" data-id="element-174" />
                  <span className="text-sm font-bold" data-id="element-175">
                    Compra 100% segura. Acceso inmediato.
                  </span>
                </div>
              </FadeIn>
            </div>

            <div className="bg-cream p-10 flex items-center justify-center" data-id="element-176">
              <FadeIn delay={0.2} data-id="element-177">
                <img src="https://cdn.magicpatterns.com/uploads/iLAN3yuZVfqLpQZBpz8PdP/Imagen_de_portada.png" alt="El Family Vault Digital" className="rounded-xl shadow-xl w-full max-w-sm mx-auto object-cover border-4 border-white" data-id="element-178" />
              </FadeIn>
            </div>
          </div>
        </div>
      </div>
    </section>;
}